(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ifl-refer-page"] && !Shopify.designMode) return;
  try {
    
const initReferralWeather = (root) => {
  root.querySelectorAll('.ifl-weather-controls').forEach(controls => {
    if (controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    const page = controls.closest('.ifl-refer-page');
    const buttons = [...controls.querySelectorAll('[data-weather-choice]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      page.dataset.weather = button.dataset.weatherChoice;
      buttons.forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
    }));
    controls.hidden = false;
  });
};
initReferralWeather(document);
document.addEventListener('shopify:section:load', event => initReferralWeather(event.target));

if (!customElements.get('ifl-reward-calculator')) {
  customElements.define('ifl-reward-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const amount = this.querySelector('[data-amount]');
      const range = this.querySelector('[data-range]');
      const savings = this.querySelector('[data-savings]');
      const credit = this.querySelector('[data-credit]');
      const error = this.querySelector('[data-error]');
      const presets = [...this.querySelectorAll('[data-preset]')];
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'});
      const update = () => {
        const value = amount.value.trim();
        const valid = /^\d+(?:\.\d{1,2})?$/.test(value) && Number(value) <= 100000000;
        amount.setAttribute('aria-invalid', String(!valid));
        error.hidden = valid;
        presets.forEach(button => button.setAttribute('aria-pressed', String(valid && Number(button.dataset.preset) === Number(value))));
        if (!valid) { savings.textContent = '—'; credit.textContent = '—'; return; }
        const [dollars, fraction = ''] = value.split('.');
        const cents = Number(dollars) * 100 + Number(fraction.padEnd(2, '0'));
        const reward = Math.round(cents / 10) / 100;
        savings.textContent = money.format(reward);
        credit.textContent = money.format(Math.floor((cents * 15 + 50) / 100) / 100);
        range.value = String(Math.min(500, Number(value)));
      };
      amount.addEventListener('input', update);
      range.addEventListener('input', () => { amount.value = range.value; update(); });
      presets.forEach(button => button.addEventListener('click', () => {
        amount.value = button.dataset.preset;
        update();
        this.classList.remove('is-changing');
        requestAnimationFrame(() => this.classList.add('is-changing'));
      }));
      this.addEventListener('animationend', () => this.classList.remove('is-changing'));
      update();
      this.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
